import http from "./http-common";
import Crypto from "./Crypto";
import { getServidor } from "../utils/Utils";

/**
 * @class AreaDataService
 * @brief Servicio de áreas que permite consultar, almacenar, actualizar y eliminado lógico.
 */

class AreaDataService {
  /**
   * @brief Obtiene el listado de todas las áreas
   * @returns {Promise<AxiosResponse<any>>} lista de las áreas
   */
  getAll() {
    return http.get(`${getServidor()}/areas/`); //listado de áreas
  }

  /**
   * @brief Obtiene la informacion del grupo asociado a un area.
   * @param idArea Identificador del area.
   * @param key Clave utilizada para encriptar los datos
   * @returns {Promise<AxiosResponse<any>>} Información del grupo asociado al area.
   */
  async getInformacionGrupo(idArea, key) {
    const datosEncriptados = await Crypto.encriptar(idArea, key);
    return http.get(`${getServidor()}/areas/informacionGrupo`, {
      params: datosEncriptados
    });
  }

  /**
   * @brief Método que permite agregar un área
   * @param data Datos del área que se desea registrar.
   * @param key Clave utilizada para encriptar los datos.
   * @returns {Promise<AxiosPromise<any>>} Respuesta de la peticion de creacion.
   */
  async create(data, key) {
    const datosEncriptados = await Crypto.encriptar(data, key);
    return http.post(`${getServidor()}/areas/`, datosEncriptados);
  }

  /**
   * @brief Método que permite obtener el listado de las áreas habilitadas.
   * @returns {Promise<AxiosResponse<any>>} Listado de las áreas habilitadas.
   */
  getHabilitados() {
    return http.get(`${getServidor()}/areas/habilitados`); //listado de áreas
  }

  /**
   * @brief Método que permite verificar si ya existe un grupo con el mismo nombre
   * @param nombre Nombre del area que se dea verificar.
   * @param key Clave utilizada para encriptar los datos.
   * @returns {Promise<AxiosPromise<any>>} Respuesta de indice si existe un area con el nombre especificado, false o true.
   */
  async getExisteAreaByNombre(nombre, key) {
    const datosEncriptados = await Crypto.encriptar(nombre, key);
    return http.get(`${getServidor()}/areas/existeAreaByNombre`, {
      params: datosEncriptados
    });
  }

  /**
  * @brief Método que permite obtener el listado de las áreas habilitadas que estan asignadas a un usuario administrativo.
  * @param id_user Indetificador del usuario administrativo.
   * @param key Clave utilizada para encriptar los datos.
   * @returns {Promise<AxiosPromise<any>>} Listado de las areas habilitadas asignadas por el usuario.
  */
  async getAreasPorAdministrador(id_user,key) {
    const datosEncriptados = await Crypto.encriptar(id_user, key);
    return http.get(`${getServidor()}/areas/areasporadministrador`,{
      params: datosEncriptados
    }); //listado de áreas
  }
}

/**
 * @brief Instancia del servicio de areas.
 * @type {AreaDataService}
 */
export default new AreaDataService();